import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Users, Sparkles, HandHeart } from 'lucide-react';
export function SocialImpactSection() {
  return <section className="py-20 bg-gradient-to-b from-white to-blue-50" dir="rtl" data-id="element-298" data-mp="2dy3l4mles28c">
      <div className="container mx-auto px-4" data-id="element-299" data-mp="28zjzknaq8sgi">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-300" data-mp="242abbaz2qmu9">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-301" data-mp="1uanu8y021tjl">
            מעבר לספורט - השפעה חברתית
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-302" data-mp="1q897w3x6gbnk">
            המועדון שלנו נולד מרצון לתרום ולעזור, והוא ממשיך להוות מרחב של נתינה
            וקהילה
          </p>
        </motion.div>

        {/* Main Story Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white rounded-3xl shadow-xl p-8 md:p-12 mb-12 border border-blue-100" data-id="element-303" data-mp="1bd331k9tiivt">
          <div className="flex items-start gap-6 mb-6" data-id="element-304" data-mp="lv5871z8wkpo">
            <div className="bg-gradient-to-br from-blue-500 to-cyan-500 p-4 rounded-2xl shadow-lg" data-id="element-305" data-mp="qsnlf4kapm3h">
              <Heart className="w-8 h-8 text-white" data-id="element-306" data-mp="1eirc6bcdxrd2" />
            </div>
            <div data-id="element-307" data-mp="1egeve1id5n1l">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-308" data-mp="1jhkow1julec6">
                מהתנדבות למפונים למועדון קהילתי
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-309" data-mp="14jimvvsgt0x1">
                פעילות המועדון התחילה מפעילות התנדבותית למפונים שהגיעו לאזור
                הכנרת במלחמה מהצפון והדרום. מתוך רצון לתת מרחב של שקט, ריפוי
                וחיבור לטבע, פתחנו את המועדון לכל מי שזקוק לרגע של נשימה.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Impact Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-310" data-mp="20plnhv615j8g">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-blue-50 hover:shadow-xl transition-shadow" data-id="element-311" data-mp="1vs2cr58jjol9">
            <div className="bg-gradient-to-br from-purple-100 to-pink-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6" data-id="element-312" data-mp="1h0tcm270iktv">
              <Users className="w-8 h-8 text-purple-600" data-id="element-313" data-mp="181ptiy7ui5fd" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-314" data-mp="1842j9xjuhk2z">
              אירוח קבוצות וגופים
            </h4>
            <p className="text-gray-600 leading-relaxed" data-id="element-315" data-mp="32g0hl4gm8vk3">
              המועדון מארח ותורם באגודות וגופים שונים - חיילים, ילדים, קבוצות
              פוסט-טראומה ועוד. אנחנו מאמינים בכוח המרפא של המים.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-blue-50 hover:shadow-xl transition-shadow" data-id="element-316" data-mp="34zx78ltjs3as">
            <div className="bg-gradient-to-br from-green-100 to-emerald-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6" data-id="element-317" data-mp="2m2cgf9782unj">
              <HandHeart className="w-8 h-8 text-green-600" data-id="element-318" data-mp="2r1fm8vv114wk" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-319" data-mp="2vyz03untbfnz">
              תרומה לעמותות חברתיות
            </h4>
            <p className="text-gray-600 leading-relaxed" data-id="element-320" data-mp="310oe9j6c09ga">
              כל הרווחים מהמועדון נתרמים לעמותות חברתיות. כל חתירה, כל שיעור, כל
              חבר - תורמים למעגל של נתינה וחיבור קהילתי.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-blue-50 hover:shadow-xl transition-shadow" data-id="element-321" data-mp="gap5x8ldjyd5">
            <div className="bg-gradient-to-br from-yellow-100 to-orange-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6" data-id="element-322" data-mp="irpnw9wnp327">
              <Sparkles className="w-8 h-8 text-orange-600" data-id="element-323" data-mp="srggg61np7zn" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-324" data-mp="spdsrsnz7qy3">
              קהילה שנותנת
            </h4>
            <p className="text-gray-600 leading-relaxed" data-id="element-325" data-mp="16kpmpxub5ddy">
              חברי המועדון הם חלק ממשהו גדול יותר - קהילה שמאמינה בערך של נתינה,
              תמיכה הדדית וחיבור אמיתי בין אנשים.
            </p>
          </motion.div>
        </div>

        {/* Bottom Quote */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-center mt-16" data-id="element-326" data-mp="1bjj3q08szmiv">
          <p className="text-2xl md:text-3xl font-light text-[#0A5F8F] italic max-w-3xl mx-auto" data-id="element-327" data-mp="1l5kanbz6hasx">
            "כשאתם חותרים איתנו, אתם לא רק משפרים את עצמכם - אתם גם עוזרים
            לאחרים"
          </p>
        </motion.div>
      </div>
    </section>;
}